import React, { useState } from 'react';
import {
    Card,
    FormH4,
    ModalButton,
    TextWrapper,
    TopLine
} from '../CrewBuilderForms/CrewBuilderElements';
import PlayerModal from '../PlayerDisplayForms/PlayerModal';

const PlayerCard = ({ player }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const projection = player?.projectedStats?.FantasyPointsDraftKings ??
        player?.ifDefenseProjectedStats?.FantasyPointsDraftKings ??
        0.0;
    console.log(player)
    return (
        <>
            <Card>
                {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
                <TextWrapper>
                    <TopLine>{player.name}</TopLine>
                    <FormH4>Team: {player.team}</FormH4>
                    <FormH4>Position: {player.position}</FormH4>
                    <FormH4 >Salary: ${player.currentSalary}</FormH4>
                    <FormH4>Projection: {projection} </FormH4>
                    {/* <BtnWrap>
                            <BtnLink
                                offset={-80}
                                primary={true}
                                dark={false}
                                dark2={false}
                            >
                                Add
                            </BtnLink>
                        </BtnWrap> */}
                </TextWrapper>
                <ModalButton onClick={openModal}>More Info</ModalButton>
            </Card>
            <PlayerModal isOpen={isModalOpen} onClose={closeModal} player={player} />
        </>
    );
};

export default PlayerCard;

